const middleware = {}

middleware['auto-login'] = require('../middleware/auto-login.js')
middleware['auto-login'] = middleware['auto-login'].default || middleware['auto-login']

export default middleware
